import type { ContentLocale } from '@/data/public-catalog'

export const collectionSystemProducts = {
  'prd-accessori-prelievo': {
    key: 'accessori',
    primaryMedia: '/media/source/images/accessori-prelievo-1.png',
    sourceLocale: 'it',
  },
  'prd-esaliva-dispositivo-per-la-raccolta-della-saliva': {
    key: 'esaliva',
    primaryMedia: '/media/source/images/ESAliva.png',
    sourceLocale: null,
  },
  'prd-provette-bd': {
    key: 'provette',
    primaryMedia: '/media/source/images/ProvetteBD-Rack-3.png',
    supportingMedia: [
      '/media/source/logos/bectondickenson_logo.png',
      '/media/source/images/ProvetteBD.png',
    ],
    sourceLocale: 'it',
  },
  'prd-x1-pro-se-semen-quality-analyzer': {
    key: 'x1',
    primaryMedia: '/media/source/images/semen1-1.png',
    supportingMedia: [
      '/media/source/images/semen3.jpg',
      '/media/source/images/semen4.jpg',
      '/media/source/images/X1.e304-en-ver2153_____-12.jpg',
    ],
    sourceLocale: 'en',
  },
} as const

export type CollectionSystemProductId = keyof typeof collectionSystemProducts
export type CollectionSystemProductKey = (typeof collectionSystemProducts)[CollectionSystemProductId]['key']

export function isCollectionSystemProductId(id: string): id is CollectionSystemProductId {
  return id in collectionSystemProducts
}

export function collectionSourceLocale(id: CollectionSystemProductId, language: ContentLocale): ContentLocale {
  return collectionSystemProducts[id].sourceLocale ?? language
}
